import { render, staticRenderFns } from "./platformCourses.vue?vue&type=template&id=fe8d99f2&scoped=true"
import script from "./platformCourses.vue?vue&type=script&lang=js"
export * from "./platformCourses.vue?vue&type=script&lang=js"
import style0 from "./platformCourses.vue?vue&type=style&index=0&id=fe8d99f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8d99f2",
  null
  
)

export default component.exports